package com.tedd.db

import kotlin.Long
import kotlin.String

public data class Focus_session(
  public val id: String,
  public val started_at: Long,
  public val ended_at: Long,
  public val focus_minutes: Long,
  public val break_minutes: Long,
  public val pomodoros: Long,
  public val task_id: String?,
  public val note: String?,
  public val skill_id: String?,
  public val created_at: Long,
  public val updated_at: Long,
  public val is_deleted: Long,
  public val deleted_at: Long?,
  public val synced_at: Long?,
)
